import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedPrice } from 'dibs-buyer-price';
import classnames from 'classnames';
import get from 'lodash.get';
import styles from './PdpSharedDetail.scss';

const PdpSharedDetailComponent = ({ detailValues, delimiter, currency, selectedSkuId }) => {
    return detailValues.map((detailValue, index) => {
        if (detailValue.skuId && detailValue.skuId !== selectedSkuId) {
            return null;
        }
        const { browseUrl, detailKey, linkOrder, displayName } = detailValue;
        const key = `${detailKey}-${index}`;
        const addDelimiter = get(detailValues, `[${index + 1}].linkOrder`) === 1 && delimiter;
        const detailClass = classnames({
            [styles.detailBlock]: !delimiter && detailValues.length > 1,
            [styles.delimiter]: addDelimiter,
            [styles.secondaryLink]: linkOrder === 2,
        });
        let detailEl;
        const convertedAmts = get(detailValue, 'price.convertedAmountList');
        let priceEl;
        const convertedAmt = convertedAmts && convertedAmts.find(amt => amt.currency === currency);
        if (convertedAmt && convertedAmt.amount) {
            priceEl = (
                <span className={styles.secondaryLink}>
                    Price:{' '}
                    <FormattedPrice currency={currency} value={Math.round(convertedAmt.amount)} />
                </span>
            );
        }
        if (browseUrl) {
            detailEl = <a href={browseUrl}>{displayName}</a>;
        } else {
            detailEl = (
                <span>
                    {displayName}
                    {priceEl}
                </span>
            );
        }
        return (
            <span key={key} className={detailClass}>
                {detailEl}
                {addDelimiter && delimiter}
            </span>
        );
    });
};

PdpSharedDetailComponent.propTypes = {
    detailValues: PropTypes.array,
    delimiter: PropTypes.string,
    currency: PropTypes.string,
    selectedSkuId: PropTypes.string,
};

export const PdpSharedDetail = createFragmentContainer(PdpSharedDetailComponent, {
    detailValues: graphql`
        fragment PdpSharedDetail_detailValues on PdpDetailValueInterface @relay(plural: true) {
            detailKey
            browseUrl
            displayName
            linkOrder
            skuId
            ... on PdpDetailVersionsValue {
                price {
                    convertedAmountList {
                        currency
                        amount
                    }
                }
            }
        }
    `,
});
